<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2022-03-30 16:09:14
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-05-18 09:22:54
 * @FilePath: \合联\oms\src\view\order\all\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <orderPage :type="'all'"></orderPage>
</template>

<script>
import orderPage from "../order-template/index.vue";
export default {
  name: "orderList",
  components: {
    orderPage
  },
  methods: {},
  data() {
    return {};
  },
  mounted() {
    console.log(this.$route);
  }
};
</script>

<style lang="scss" scoped></style>
